import { Component, EventEmitter, Input, Output } from '@angular/core';
import { V3ScoresOverview } from '../v3-scores-overview/v3-scores-overview';
import { V3NewsOverview } from '../v3-news-overview/v3-news-overview';
import { V3AnalystsOverview } from '../v3-analysts-overview/v3-analysts-overview';
import { V3CompetitorOverview } from '../v3-competitor-overview/v3-competitor-overview';
import { V3EarningsOverview } from '../v3-earnings-overview/v3-earnings-overview';
import { V3EarningsCalendar } from '../v3-earnings-calendar/v3-earnings-calendar';
import { FundamentalScoreSystemKey } from '../services/api/fundamental-scores';

// V3's main/overview page — counterpart to V3CompanyProfile. See v3-scores-overview/CLAUDE.md.
// A thin, theme-agnostic container meant to hold every future overview card (News/Analysts/
// Earnings/Competitor) as a sibling — add to it, don't rebuild it.
@Component({
  selector: 'app-v3-overview',
  imports: [
    V3ScoresOverview,
    V3NewsOverview,
    V3AnalystsOverview,
    V3EarningsOverview,
    V3EarningsCalendar,
    V3CompetitorOverview,
  ],
  standalone: true,
  templateUrl: './v3-overview.html',
  styleUrl: './v3-overview.scss',
})
export class V3Overview {
  @Input() currentPrice: number | null = null;
  /** Live EUR price per ISIN, for the Competitor card. */
  @Input() livePrices: Record<string, number> | null = null;
  @Output() navigate = new EventEmitter<FundamentalScoreSystemKey | undefined>();
  @Output() navigateNews = new EventEmitter<void>();
  @Output() navigateAnalysts = new EventEmitter<void>();
  @Output() navigateCompetitor = new EventEmitter<void>();
  @Output() navigateEarnings = new EventEmitter<void>();
  @Output() navigateToInstrument = new EventEmitter<string>();
}
